<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="pd-t-5px">Agenda Edit</h2>
    <div contentContainer>
        <form [formGroup]="agendaEditBox" >
                <div class="row justify-content-between">
                    <mat-form-field class="body-font-size col-md-4">
                        <mat-label class="body-font-size">Agenda Title</mat-label>
                        <input class="body-font-size" matInput formControlName="agendaTitle">
                    </mat-form-field>
                    <mat-form-field class="body-font-size col-md-4">
                        <mat-label class="body-font-size">Duration</mat-label> 
                        <input formControlName="agendaDuration" class="body-font-size" maxlength = '3' (keypress)="numberOnly($event)" matInput>
                    </mat-form-field> 
                </div> 
                <div></div>
                <!-- <div *ngFor ="let a of agendaList.agendaPresenterList" class="input-field-wrapper">
                    <mat-form-field class="presenter-name body-font-size">
                        <mat-label  class="body-font-size">Presented By</mat-label>
                        <input #name id="{{agendaList.agendaId}}" [attr.agid]="agendaList.agendaId" [innerHtml]="agendaList | safeAgneda" class="agendaEditTitleCls body-font-size"  matInput (change) = "trigger($event, agendaList.agendaId)" (keyup.enter) = "trigger($event, agendaList.agendaId)" (click)="loadPresenter($event.target, agendaList.agendaId)">
                    </mat-form-field> 
                </div> -->
                <div class="input-field-wrapper">
                    <mat-form-field class="presenter-name body-font-size">
                        <mat-label  class="body-font-size">Presented By</mat-label>
                        <input #name id="presenterField" class="agendaEditTitleCls body-font-size"  matInput (focus) = "trigger($event, 'presenterField')" (keyup.enter) = "trigger($event, 'presenterField')" (click)="loadPresenter($event.target, 'presenterField')">
                    </mat-form-field> 
                </div>
                <div class="d-flex flex-wrap">
                    <div  class="d-flex">
                        <div  class="accordion-item-container" id="displayAttendeeSec" *ngFor ="let a of agendaList.agendaPresenterList;let i = index">
                            <div class= "global-border-container-item">
                                
                                <div class="participant-detail-container">
                                    <div>
                                            <p id="{{agendaList.agendaId}}" [attr.agid]="agendaList.agendaId" class="agendaEditTitleCls body-font-size" class="para-container">{{a.presenterName}}</p>
                                    </div>          
                                </div>
                                <button mat-icon-button class="participant-cancel-button" (click) = "removePresenteeJson(i,a)">
                                    <mat-icon class="participant-cancel-icon">cancel</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class = "d-flex" *ngIf = "newArrayContainer.length != 0">
                        <div  class="accordion-item-container" id="displayAttendeeSec" *ngFor ="let a of newArrayContainer;let i = index">
                            <div class= "global-border-container-item">
                                
                                <div class="participant-detail-container">
                                    <div>
                                            <p id="{{agendaList.agendaId}}"[attr.agid]="agendaList.agendaId" class="agendaEditTitleCls body-font-size" class="para-container">{{a}}</p>
                                    </div>          
                                </div>
                                <button mat-icon-button class="participant-cancel-button" (click) = "removePresentee(i,a)">
                                    <mat-icon class="participant-cancel-icon">cancel</mat-icon>
                                </button>
                            </div>
                        </div>  
                    </div>
                  
                </div>

            <!-- <form class="input-field-wrapper">
                <mat-form-field class="duration-container body-font-size">
                    <mat-label class="body-font-size">Duration</mat-label> 
                    <input class="body-font-size" matInput value="60 Minutes">
                </mat-form-field> 
            </form>   -->
            <br>
            <div>
                <mat-form-field class="input-field-wrapper">
                    <mat-label class="body-font-size">Add Description</mat-label>
                    <textarea formControlName="agendaDesc"  matInput class="notes-text-area body-font-size"></textarea>
                </mat-form-field>
                <!-- <textarea matInput class="notes-text-area body-font-size" placeholder="Add Notes..."></textarea> -->
            </div>

                                        <!-- No Need for the requirements -->

            <!-- <div >
                <mat-form-field class="input-field-wrapper">
                    <mat-label class="body-font-size">Predefined Notes</mat-label>
                    <textarea formControlName="defaultNotes" matInput class="notes-text-area body-font-size"></textarea>
                </mat-form-field> -->
                <!-- <textarea class="predefined-notes-area body-font-size" placeholder="Predefined Notes..."></textarea> -->
            <!-- </div>   -->
        </form>
            <!-- <form>
                <mat-form-field  class="input-field-wrapper">
                    <mat-label class="body-font-size">Add Remarks</mat-label>
                    <textarea matInput class="notes-text-area body-font-size"></textarea>
                </mat-form-field>
                <textarea class="text-area-container body-font-size" placeholder="Add Remarks..."></textarea>
            </form> -->
    </div>
    <div>

    </div>
    <button (click)="updateAgendaEditBox()" mat-raised-button actions class="button-container primary">
        SAVE
    </button>
    <button mat-raised-button actions class="button-container primary" mat-dialog-close>
        CANCEL
    </button>
</app-centre-small-opener>